<template>
  <v-navigation-drawer v-model="isNavDrawerOpen" app>
    <AddNewItemButton />
    <v-list nav dense>
      <v-list-item-group>
        <v-list-item
          v-for="item in drawerLaunchItems"
          :key="item"
          @click="navigate(item)"
        >
          <v-list-item-icon>
            <v-icon :color="feature[item].color">
              {{ feature[item].icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ feature[item].title }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <FeedbackButton />
  </v-navigation-drawer>
</template>

<script>
import { watch, ref } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'
import { feature } from '@/use/Constants'
import AddNewItemButton from '@/components/layout/AddNewItemButton'
import FeedbackButton from '@/components/layout/FeedbackButton'

export default {
  name: 'NavDrawer',
  components: {
    AddNewItemButton,
    FeedbackButton
  },
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    state: {
      type: Number,
      default: 0
    }
  },
  setup(props, context) {
    const isNavDrawerOpen = ref(true)

    const router = useRouter()
    const drawerLaunchItems = [
      'dashboard',
      'services',
      'tasks',
      'customers',
      'sites'
    ]

    watch(
      () => props.state,
      () => {
        isNavDrawerOpen.value = !isNavDrawerOpen.value
      }
    )

    const navigate = item => {
      router.push({ name: feature[item].routerName })
      context.emit('close')
    }

    return { feature, isNavDrawerOpen, drawerLaunchItems, navigate }
  }
}
</script>

<style lang="scss" scoped></style>
